import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { fetchUserProfile, fetchUserSubscriptions, cancelSubscription } from "../apiService";
import { Subscription, UserProfile } from "../Interface";
import { useNavigate } from "react-router-dom";
import { useGlobalError } from '../Components/GlobalErrorContext';
import '../App.css';

const Settings = () => {
  const [accountDetails, setAccountDetails] = useState<UserProfile | null>(null);
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelForm, setShowCancelForm] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);

  const { showErrorModal } = useGlobalError();


  const navigate = useNavigate(); 

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
      const portalEndCustomerId = localStorage.getItem('portalEndCustomerId');
    
      if (!accessToken || !portalEndCustomerId) {
        navigate('/login'); // Redirect to login if no credentials
        return;
      }

    const fetchData = async () => {
      try {
        setLoading(true);
        const userProfile = await fetchUserProfile(portalEndCustomerId); // Fetch user profile
        const userSubscriptions = await fetchUserSubscriptions(portalEndCustomerId); // Fetch user subscriptions

        setAccountDetails(userProfile);
        setSubscription(userSubscriptions[0]); // Assuming the first subscription is displayed
      } catch (err) {
        console.error("Error fetching account details:", err);
        setError("Failed to load account details.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const handleDeleteClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmModal(false);
    setShowCancelForm(true);
  };

const handleCancelFormSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!cancelReason || !termsAccepted) {
    setShowCancelForm(false); // Hide modal first
    showErrorModal('Please complete the form and accept the terms.');
    return;
  }

  if (!subscription) {
    setShowCancelForm(false); // Hide modal first
    showErrorModal('No subscription found to cancel.');
    return;
  }

  try {
    setLoading(true);

    const result = await cancelSubscription(subscription.id, cancelReason);

    if (result.success) {
      alert('Your cancellation request has been submitted successfully.');
      setShowCancelForm(false); // Close the form
    } else {
      setShowCancelForm(false); // Hide modal
      showErrorModal(`Cancellation failed: ${result.message}`);
    }
  } catch (error) {
    console.error('Error during cancellation:', error);
    setShowCancelForm(false); // Hide modal
    showErrorModal('An unexpected error occurred. Please try again.');
  } finally {
    setLoading(false);
  }
};



  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-5">
      <h2 style={{ margin: 0, color: "#ec4d13" }}>Account SETTINGS</h2>
      <br/>
      <div className="card mb-4">
        <h4 className="mb-1" style={{ color: "#E2520F", fontWeight: "bold"}}>USER</h4>
        <hr/>
        <div className="card-body">
          <p><strong>User:</strong> {accountDetails?.firstName} {accountDetails?.lastName}</p>
          <p><strong>Phone Number:</strong> {accountDetails?.mobileNumber}</p>
          <p><strong>Email:</strong> {accountDetails?.email}</p>
          <p><strong>Address:</strong> {accountDetails?.streetAddress}</p>
          <p><strong>RSA-ID / Passport:</strong> {accountDetails?.identificationReference}</p>
        </div>
      </div>

      <div className="card mb-4">
        <h4 className="mb-1" style={{ color: "#E2520F", fontWeight: "bold"}}>PACKAGE</h4>
        <hr/>
        <div className="card-body">
          <p><strong>Package Name:</strong> {subscription?.portalProduct?.name}</p>
          <p><strong>Speed:</strong> {subscription?.portalProduct?.speedDownMbps} Mbps</p>
          <p><strong>Price:</strong> {subscription?.portalProduct?.price} {subscription?.portalProduct?.currency} / Month</p>
          <p>
            <strong>Coming Billing Date:</strong>{' '}
            {subscription?.nextBillingDate
              ? new Date(subscription.nextBillingDate).toLocaleDateString()
              : 'N/A'}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <button className="btn btn-danger" onClick={handleDeleteClick} style={{ backgroundColor: '#ec4d13', borderColor: '#ec4d13' }}>
          Delete Account
        </button>
        <br/>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>

      {/* Confirm Popup */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header style={{ backgroundColor: '#e2520f', color: 'white' }}>
          <Modal.Title>Confirm Cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to cancel your subscription and delete your account?
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button variant="secondary" onClick={() => setShowConfirmModal(false)} style={{ backgroundColor: '#ec4d13', borderColor: '#ec4d13' }}>
              No
            </Button>
            <Button variant="danger" onClick={handleConfirmDelete} style={{ backgroundColor: '#ec4d13', borderColor: '#ec4d13' }}>
              Yes, Proceed
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Cancellation Form Modal */}
      <Modal show={showCancelForm} onHide={() => setShowCancelForm(false)} centered>
        <Modal.Header style={{ backgroundColor: '#e2520f', color: 'white' }}>
          <Modal.Title>Cancellation Request</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleCancelFormSubmit}>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Reason for Cancellation</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Check
                type="checkbox"
                label="I accept the cancellation terms and conditions."
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                required
              />
              <small className="text-muted d-block mt-2">
                • R1,000 cancellation fee applies if membership is less than 12 months.<br />
                • Cancellation takes effect next billing cycle.<br />
                • Pending invoices must be settled first.
              </small>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button variant="secondary" onClick={() => setShowCancelForm(false)} style={{ backgroundColor: '#ec4d13', borderColor: '#ec4d13' }}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" style={{ backgroundColor: '#ec4d13', borderColor: '#ec4d13' }}>
              Submit Request
            </Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default Settings;
